module.exports = __webpack_public_path__ + "static/media/Menu-2.9eebbfb9.jpg";